export const truncateString = (str: string, lettersCount: number): string => {
  if (str.length > lettersCount) {
    return str.slice(0, lettersCount) + '...'
  } else {
    return str
  }
}
